import { createFileRoute } from '@tanstack/react-router';
import { AdminFeaturesPage } from '../../features/billing';

export const Route = createFileRoute('/admin/features')({ component: AdminFeaturesPage });
